import { render, staticRenderFns } from "./FamilyDetail.vue?vue&type=template&id=03446359&scoped=true"
import script from "./FamilyDetail.vue?vue&type=script&lang=js"
export * from "./FamilyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03446359",
  null
  
)

export default component.exports